import { Application } from './Application';

export async function bootstrap(container: HTMLElement): Promise<Application> {
  const app = new Application(container);
  await app.start();
  return app;
}
